import { ccc } from "."

export const HCenter = ccc({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
})
